// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The menu. Wide screens: a rail beside the conversation, divided by a
 * hairline. Phones and tablets: a panel on the raised surface that comes in
 * from the menu button's side over a scrim (BRAND_SPEC §11.0 sheets).
 */
.sidebar {
  width: 280px;
  min-width: 280px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 12px 12px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  background: var(--brand-bg);
  color: var(--brand-fg);
  border-right: 1px solid var(--brand-line);
  overflow-y: auto;
  overscroll-behavior: contain;
}

.sidebar-brand {
  flex: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 44px;
  padding: 0 0 0 8px;
  margin-bottom: 12px;
}

.sidebar-lockup {
  display: flex;
  color: var(--brand-fg);
}

.sidebar-lockup .apr-lockup {
  display: block;
  height: 22px;
  width: auto;
}

.sidebar-close {
  display: none;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  color: var(--brand-fg);
}

.sidebar-close:hover {
  background: var(--brand-surface-2);
}

.sidebar-new-chat {
  flex: none;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  margin: 0 0 12px;
  padding: 0 14px;
  border-radius: var(--radius-md);
  border: 1px solid var(--brand-line-control);
  color: var(--brand-fg);
  font-size: 1rem;
  font-weight: 600;
  text-align: left;
}

.sidebar-new-chat:hover {
  background: var(--brand-surface-2);
}

.sidebar-nav {
  flex: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 16px;
}

.sidebar-nav-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 44px;
  padding: 0 10px 0 14px;
  border-radius: var(--radius-md);
  color: var(--brand-muted);
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
  text-decoration: none;
}

.sidebar-nav-item:hover {
  color: var(--brand-fg);
  background: var(--brand-surface-2);
  text-decoration: none;
}

/* The current view: white words and a 2 px bar, never a fill alone. */
.sidebar-nav-item.active {
  color: var(--brand-fg);
}

.sidebar-nav-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 2px;
  border-radius: 1px;
  background: var(--brand-fg);
}

.nav-text {
  flex: 1;
  min-width: 0;
}

.nav-hint {
  display: block;
  margin-top: 1px;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.35;
  color: var(--brand-subtle);
}

.sidebar-nav-item:has(.nav-hint) {
  min-height: 56px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.nav-ext {
  margin-left: auto;
  color: var(--brand-muted);
}

.nav-dot {
  margin-left: auto;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--brand-fg);
}

.sidebar-nav-item.sub {
  min-height: 44px;
  padding-left: 30px;
  font-size: 0.9375rem;
}

.sidebar-section-label {
  flex: none;
  padding: 8px 14px 6px;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.35;
  color: var(--brand-muted);
}

.sidebar-chats {
  flex: 1;
  /* Never squeezed away by the footer: below this the whole menu scrolls. */
  min-height: 140px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: 12px;
}

.sidebar-chat {
  display: flex;
  align-items: stretch;
  border-radius: var(--radius-md);
}

.sidebar-chat:hover {
  background: var(--brand-surface-2);
}

.sidebar-chat.active {
  box-shadow: inset 2px 0 0 var(--brand-fg);
}

.sidebar-chat-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  min-height: 52px;
  padding: 6px 8px 6px 14px;
  color: var(--brand-fg);
  text-align: left;
}

.sidebar-chat-title {
  font-size: 0.9375rem;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-chat-when {
  font-size: 0.8125rem;
  color: var(--brand-subtle);
}

.sidebar-chat-delete {
  flex: none;
  display: grid;
  place-items: center;
  width: 44px;
  border-radius: var(--radius-md);
  color: var(--brand-muted);
  opacity: 0;
}

.sidebar-chat:hover .sidebar-chat-delete,
.sidebar-chat-delete:focus-visible {
  opacity: 1;
}

.sidebar-chat-delete:hover {
  color: var(--brand-fg);
  background: var(--brand-surface);
}

/* Touch screens have no hover: keep the delete control visible. */
@media (hover: none) {
  .sidebar-chat-delete { opacity: 1; }
}

.sidebar-guest-hint {
  margin: 0 4px;
  padding: 14px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--brand-line);
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-fg-read);
}

.sidebar-guest-hint p {
  margin: 0 0 12px;
}

.sidebar-signin-btn {
  width: 100%;
  font-size: 0.9375rem;
}

.sidebar-empty {
  padding: 8px 14px;
  font-size: 0.9375rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.sidebar-footer {
  flex: none;
  border-top: 1px solid var(--brand-line);
  padding-top: 8px;
}

.sidebar-setting {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 48px;
  padding: 0 10px 0 14px;
  border-radius: var(--radius-md);
  color: var(--brand-fg);
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.sidebar-setting:hover {
  background: var(--brand-surface-2);
}

.sidebar-setting .nav-text small {
  display: block;
  margin-top: 1px;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.35;
  color: var(--brand-muted);
}

.sidebar-setting:has(small) {
  padding-top: 6px;
  padding-bottom: 6px;
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 48px;
  padding: 0 4px 0 14px;
}

.sidebar-user-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--brand-fg);
  text-align: left;
}

.sidebar-user-name.as-button {
  min-height: 44px;
  padding: 0;
}

.sidebar-user-action {
  min-height: 44px;
  padding: 0 8px;
  font-size: 0.9375rem;
  color: var(--brand-fg);
  text-decoration: underline;
  text-underline-offset: 0.2em;
  white-space: nowrap;
}

.sidebar-user-action.strong {
  min-height: 44px;
  padding: 0 16px;
  border: 2px solid var(--brand-fg);
  border-radius: var(--radius-md);
  font-weight: 600;
  text-decoration: none;
}

.sidebar-give {
  margin: 4px 14px 10px;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.sidebar-give-title {
  display: block;
  margin-bottom: 2px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--brand-fg);
}

.sidebar-give-cta {
  color: var(--brand-fg);
  text-decoration: underline;
  text-underline-offset: 0.2em;
  white-space: nowrap;
}

.sidebar-give-cta:hover {
  text-decoration-thickness: 2px;
}

/* During a crisis hold (utils/giving.js) the 988 line stands where support
   was: the same quiet line as in the conversation (ChatView.css), with the
   menu's own spacing. */
.sidebar-give--crisis .cv-crisis-line {
  margin: 0;
  max-width: none;
}

/* "Stay in the loop" (the email list): one quiet line under support. */
.sidebar-loop {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  margin: -8px 14px 4px;
  padding: 0;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--brand-fg);
  text-align: left;
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.2em;
}

.sidebar-loop:hover {
  text-decoration-thickness: 2px;
}

.sidebar-loop .apr-icon {
  color: var(--brand-muted);
}

.sidebar-loop.done {
  font-weight: 500;
  color: var(--brand-muted);
  text-decoration-line: none;
}

/* Pastor Rob's book: a title in his own serif and one link. */
.sidebar-book {
  margin: 4px 14px 10px;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--brand-muted);
}

.sidebar-book-title {
  display: block;
  font-family: var(--font-serif);
  font-style: normal;
  font-weight: 440;
  font-size: 1rem;
  line-height: 1.3;
  font-variation-settings: "opsz" 18;
  color: var(--brand-fg);
}

.sidebar-book .sidebar-give-cta {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 0.875rem;
  font-weight: 600;
}

/* "Follow The Net": three plain words, each a full-size target. */
.sidebar-follow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 14px;
  margin: 0 14px 2px;
  font-size: 0.8125rem;
  line-height: 1.3;
  color: var(--brand-subtle);
}

.sidebar-follow-label {
  flex-basis: 100%;
  font-weight: 600;
  color: var(--brand-muted);
}

.sidebar-follow a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--brand-fg);
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.sidebar-promise {
  margin: 0 14px 6px;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--brand-subtle);
}

.sidebar-policies {
  padding: 0 14px;
  font-size: 0.8125rem;
  line-height: 2;
  color: var(--brand-subtle);
}

.sidebar-policies a {
  color: var(--brand-muted);
}

.sidebar-about {
  margin: 4px 14px 2px;
  font-size: 0.8125rem;
  line-height: 1.45;
  color: var(--brand-subtle);
}

.sidebar-about a {
  color: var(--brand-muted);
}

.sidebar-backdrop {
  display: none;
}

/* The fold button (wide screens) and the rail's own icons (folded only). */
.sidebar-fold {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  color: var(--brand-muted);
}

.sidebar-fold:hover {
  color: var(--brand-fg);
  background: var(--brand-surface-2);
}

.sidebar-fold-mark {
  display: none;
  color: var(--brand-fg);
}

.sidebar-fold-mark .apr-mark {
  display: block;
  height: 22px;
  width: auto;
}

.rail-only {
  display: none;
}

.sidebar-rail-btn {
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  color: var(--brand-muted);
  text-decoration: none;
}

.sidebar-rail-btn:hover {
  color: var(--brand-fg);
  background: var(--brand-surface-2);
}

/*
 * Folded (wide screens only): a 68 px rail of 44 px icons. Every word stays
 * in the page for screen readers; each icon shows its name beside it on
 * hover or keyboard focus. Saved conversations, the account line, support's
 * sentence and the policies wait in the open menu.
 */
@media (min-width: 901px) {
  .sidebar.folded {
    width: 68px;
    min-width: 68px;
    padding: 12px 12px calc(12px + env(safe-area-inset-bottom, 0px));
    align-items: center;
    overflow: visible;
  }

  .sidebar.folded .sidebar-brand {
    padding: 0;
    margin-bottom: 8px;
    justify-content: center;
  }

  .sidebar.folded .sidebar-lockup,
  .sidebar.folded .sidebar-section-label,
  .sidebar.folded .sidebar-chats,
  .sidebar.folded .sidebar-user,
  .sidebar.folded .sidebar-give,
  .sidebar.folded .sidebar-loop,
  .sidebar.folded .sidebar-promise,
  .sidebar.folded .sidebar-book,
  .sidebar.folded .sidebar-follow,
  .sidebar.folded .sidebar-policies,
  .sidebar.folded .sidebar-about,
  .sidebar.folded .sidebar-nav-item.sub,
  .sidebar.folded .nav-ext,
  .sidebar.folded .apr-switch-track {
    display: none;
  }

  .sidebar.folded .nav-text,
  .sidebar.folded .rail-words {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
  }

  .sidebar.folded .sidebar-new-chat {
    width: 44px;
    min-height: 44px;
    padding: 0;
    justify-content: center;
  }

  .sidebar.folded .sidebar-nav {
    align-items: center;
  }

  .sidebar.folded .sidebar-nav-item,
  .sidebar.folded .sidebar-nav-item:has(.nav-hint),
  .sidebar.folded .sidebar-setting,
  .sidebar.folded .sidebar-setting:has(small) {
    width: 44px;
    min-height: 44px;
    padding: 0;
    justify-content: center;
  }

  /* The current view's bar sits on the rail's edge. */
  .sidebar.folded .sidebar-nav-item.active::before {
    left: -12px;
  }

  .sidebar.folded .nav-dot {
    position: absolute;
    top: 8px;
    right: 8px;
    margin: 0;
  }

  /* A switch that is on keeps a filled square behind its icon. */
  .sidebar.folded .sidebar-setting[aria-checked="true"] {
    background: var(--brand-surface-2);
  }

  .sidebar.folded .sidebar-footer {
    margin-top: auto;
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .sidebar.folded .rail-only {
    display: grid;
  }

  .sidebar.folded .sidebar-fold-mark {
    display: block;
  }

  .sidebar.folded .sidebar-fold-icon {
    display: none;
  }

  .sidebar.folded .sidebar-fold:hover .sidebar-fold-mark,
  .sidebar.folded .sidebar-fold:focus-visible .sidebar-fold-mark {
    display: none;
  }

  .sidebar.folded .sidebar-fold:hover .sidebar-fold-icon,
  .sidebar.folded .sidebar-fold:focus-visible .sidebar-fold-icon {
    display: block;
  }

  /* Names on hover and keyboard focus, to the right of the rail. */
  .sidebar.folded [data-tip] {
    position: relative;
  }

  .sidebar.folded [data-tip]:hover::after,
  .sidebar.folded [data-tip]:focus-visible::after {
    content: attr(data-tip);
    position: absolute;
    z-index: 70;
    left: calc(100% + 12px);
    top: 50%;
    transform: translateY(-50%);
    padding: 6px 10px;
    border-radius: var(--radius-md);
    background: var(--brand-fg);
    color: var(--brand-bg);
    font-family: var(--font-sans);
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    pointer-events: none;
  }
}

@media (max-width: 900px) {
  .sidebar {
    position: fixed;
    z-index: 60;
    top: 0;
    right: 0;
    bottom: 0;
    width: min(86vw, 340px);
    min-width: 0;
    padding-top: calc(6px + env(safe-area-inset-top, 0px));
    padding-right: calc(12px + env(safe-area-inset-right, 0px));
    background: var(--brand-surface);
    border-right: 0;
    border-left: 1px solid var(--brand-line-control);
    transform: translateX(105%);
    visibility: hidden;
    transition: transform var(--dur-base) var(--ease-out), visibility 0s linear var(--dur-base);
  }

  .sidebar.open {
    transform: none;
    visibility: visible;
    transition: transform var(--dur-base) var(--ease-out), visibility 0s linear 0s;
  }

  .sidebar-close {
    display: grid;
  }

  .sidebar-fold {
    display: none;
  }

  .sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 55;
    background: var(--brand-scrim);
    animation: aprScrimIn var(--dur-fast) var(--ease-out);
  }
}

/* Short screens (landscape phones): one scroll for the whole menu instead of
   a conversation list squeezed to a sliver between the nav and the footer. */
@media (max-height: 500px) {
  .sidebar {
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .sidebar-chats {
    flex: none;
    overflow: visible;
  }
}

/* ---- Rob's voice, for the team only (TeamVoicePick): two choices joined like the answer style ---- */

.sidebar-voice-pick {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 10px 10px 14px;
}

.sidebar-voice-pick-label {
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.35;
  color: var(--brand-fg);
}

.sidebar-voice-pick-label small {
  display: block;
  margin-top: 1px;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.35;
  color: var(--brand-muted);
}

.sidebar-voice-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.sidebar-voice-option {
  min-width: 0;
  min-height: 44px;
  padding: 0 10px;
  border: 1px solid var(--brand-line-control);
  background: transparent;
  color: var(--brand-muted);
  font-size: 0.875rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.sidebar-voice-option:first-child { border-radius: var(--radius-md) 0 0 var(--radius-md); }
.sidebar-voice-option:last-child { border-radius: 0 var(--radius-md) var(--radius-md) 0; margin-left: -1px; }
.sidebar-voice-option:hover { color: var(--brand-fg); }

.sidebar-voice-option.on {
  position: relative;
  z-index: 1;
  border-color: var(--brand-fg);
  box-shadow: inset 0 0 0 1px var(--brand-fg);
  color: var(--brand-fg);
}

/* The folded rail has no room for it: it waits in the open menu. */
@media (min-width: 901px) {
  .sidebar.folded .sidebar-voice-pick { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,6DAA6D;EAC7D,2BAA2B;EAC3B,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,0EAA0E;EAC1E,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,kEAAkE;AAClE;EACE,uBAAuB,UAAU,EAAE;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;wBAEwB;AACxB;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;;;;EAKE;AACF;EACE;IACE,WAAW;IACX,eAAe;IACf,gEAAgE;IAChE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;;;;;;;;;;;;;;IAcE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;;IAIE,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,uBAAuB;EACzB;;EAEA,oDAAoD;EACpD;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;EACX;;EAEA,+DAA+D;EAC/D;IACE,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA,iEAAiE;EACjE;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,+BAA+B;IAC/B,2BAA2B;IAC3B,sBAAsB;IACtB,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;IACX,MAAM;IACN,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,YAAY;IACZ,sDAAsD;IACtD,2DAA2D;IAC3D,gCAAgC;IAChC,eAAe;IACf,gDAAgD;IAChD,2BAA2B;IAC3B,kBAAkB;IAClB,2FAA2F;EAC7F;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,8EAA8E;EAChF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,WAAW;IACX,8BAA8B;IAC9B,qDAAqD;EACvD;AACF;;AAEA;6EAC6E;AAC7E;EACE;IACE,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA,uGAAuG;;AAEvG;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oCAAoC,oDAAoD,EAAE;AAC1F,mCAAmC,oDAAoD,EAAE,iBAAiB,EAAE;AAC5G,8BAA8B,sBAAsB,EAAE;;AAEtD;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,sCAAsC,aAAa,EAAE;AACvD","sourcesContent":["/*\n * The menu. Wide screens: a rail beside the conversation, divided by a\n * hairline. Phones and tablets: a panel on the raised surface that comes in\n * from the menu button's side over a scrim (BRAND_SPEC §11.0 sheets).\n */\n.sidebar {\n  width: 280px;\n  min-width: 280px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 12px 12px;\n  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));\n  background: var(--brand-bg);\n  color: var(--brand-fg);\n  border-right: 1px solid var(--brand-line);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.sidebar-brand {\n  flex: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 44px;\n  padding: 0 0 0 8px;\n  margin-bottom: 12px;\n}\n\n.sidebar-lockup {\n  display: flex;\n  color: var(--brand-fg);\n}\n\n.sidebar-lockup .apr-lockup {\n  display: block;\n  height: 22px;\n  width: auto;\n}\n\n.sidebar-close {\n  display: none;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  color: var(--brand-fg);\n}\n\n.sidebar-close:hover {\n  background: var(--brand-surface-2);\n}\n\n.sidebar-new-chat {\n  flex: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 48px;\n  margin: 0 0 12px;\n  padding: 0 14px;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--brand-line-control);\n  color: var(--brand-fg);\n  font-size: 1rem;\n  font-weight: 600;\n  text-align: left;\n}\n\n.sidebar-new-chat:hover {\n  background: var(--brand-surface-2);\n}\n\n.sidebar-nav {\n  flex: none;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 16px;\n}\n\n.sidebar-nav-item {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-height: 44px;\n  padding: 0 10px 0 14px;\n  border-radius: var(--radius-md);\n  color: var(--brand-muted);\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: left;\n  text-decoration: none;\n}\n\n.sidebar-nav-item:hover {\n  color: var(--brand-fg);\n  background: var(--brand-surface-2);\n  text-decoration: none;\n}\n\n/* The current view: white words and a 2 px bar, never a fill alone. */\n.sidebar-nav-item.active {\n  color: var(--brand-fg);\n}\n\n.sidebar-nav-item.active::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 10px;\n  bottom: 10px;\n  width: 2px;\n  border-radius: 1px;\n  background: var(--brand-fg);\n}\n\n.nav-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.nav-hint {\n  display: block;\n  margin-top: 1px;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.35;\n  color: var(--brand-subtle);\n}\n\n.sidebar-nav-item:has(.nav-hint) {\n  min-height: 56px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.nav-ext {\n  margin-left: auto;\n  color: var(--brand-muted);\n}\n\n.nav-dot {\n  margin-left: auto;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--brand-fg);\n}\n\n.sidebar-nav-item.sub {\n  min-height: 44px;\n  padding-left: 30px;\n  font-size: 0.9375rem;\n}\n\n.sidebar-section-label {\n  flex: none;\n  padding: 8px 14px 6px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: var(--brand-muted);\n}\n\n.sidebar-chats {\n  flex: 1;\n  /* Never squeezed away by the footer: below this the whole menu scrolls. */\n  min-height: 140px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-bottom: 12px;\n}\n\n.sidebar-chat {\n  display: flex;\n  align-items: stretch;\n  border-radius: var(--radius-md);\n}\n\n.sidebar-chat:hover {\n  background: var(--brand-surface-2);\n}\n\n.sidebar-chat.active {\n  box-shadow: inset 2px 0 0 var(--brand-fg);\n}\n\n.sidebar-chat-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n  min-height: 52px;\n  padding: 6px 8px 6px 14px;\n  color: var(--brand-fg);\n  text-align: left;\n}\n\n.sidebar-chat-title {\n  font-size: 0.9375rem;\n  line-height: 1.35;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-chat-when {\n  font-size: 0.8125rem;\n  color: var(--brand-subtle);\n}\n\n.sidebar-chat-delete {\n  flex: none;\n  display: grid;\n  place-items: center;\n  width: 44px;\n  border-radius: var(--radius-md);\n  color: var(--brand-muted);\n  opacity: 0;\n}\n\n.sidebar-chat:hover .sidebar-chat-delete,\n.sidebar-chat-delete:focus-visible {\n  opacity: 1;\n}\n\n.sidebar-chat-delete:hover {\n  color: var(--brand-fg);\n  background: var(--brand-surface);\n}\n\n/* Touch screens have no hover: keep the delete control visible. */\n@media (hover: none) {\n  .sidebar-chat-delete { opacity: 1; }\n}\n\n.sidebar-guest-hint {\n  margin: 0 4px;\n  padding: 14px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--brand-line);\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-fg-read);\n}\n\n.sidebar-guest-hint p {\n  margin: 0 0 12px;\n}\n\n.sidebar-signin-btn {\n  width: 100%;\n  font-size: 0.9375rem;\n}\n\n.sidebar-empty {\n  padding: 8px 14px;\n  font-size: 0.9375rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.sidebar-footer {\n  flex: none;\n  border-top: 1px solid var(--brand-line);\n  padding-top: 8px;\n}\n\n.sidebar-setting {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-height: 48px;\n  padding: 0 10px 0 14px;\n  border-radius: var(--radius-md);\n  color: var(--brand-fg);\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: left;\n}\n\n.sidebar-setting:hover {\n  background: var(--brand-surface-2);\n}\n\n.sidebar-setting .nav-text small {\n  display: block;\n  margin-top: 1px;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.35;\n  color: var(--brand-muted);\n}\n\n.sidebar-setting:has(small) {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.sidebar-user {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-height: 48px;\n  padding: 0 4px 0 14px;\n}\n\n.sidebar-user-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--brand-fg);\n  text-align: left;\n}\n\n.sidebar-user-name.as-button {\n  min-height: 44px;\n  padding: 0;\n}\n\n.sidebar-user-action {\n  min-height: 44px;\n  padding: 0 8px;\n  font-size: 0.9375rem;\n  color: var(--brand-fg);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n  white-space: nowrap;\n}\n\n.sidebar-user-action.strong {\n  min-height: 44px;\n  padding: 0 16px;\n  border: 2px solid var(--brand-fg);\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.sidebar-give {\n  margin: 4px 14px 10px;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.sidebar-give-title {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--brand-fg);\n}\n\n.sidebar-give-cta {\n  color: var(--brand-fg);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n  white-space: nowrap;\n}\n\n.sidebar-give-cta:hover {\n  text-decoration-thickness: 2px;\n}\n\n/* During a crisis hold (utils/giving.js) the 988 line stands where support\n   was: the same quiet line as in the conversation (ChatView.css), with the\n   menu's own spacing. */\n.sidebar-give--crisis .cv-crisis-line {\n  margin: 0;\n  max-width: none;\n}\n\n/* \"Stay in the loop\" (the email list): one quiet line under support. */\n.sidebar-loop {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  margin: -8px 14px 4px;\n  padding: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--brand-fg);\n  text-align: left;\n  text-decoration-line: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 0.2em;\n}\n\n.sidebar-loop:hover {\n  text-decoration-thickness: 2px;\n}\n\n.sidebar-loop .apr-icon {\n  color: var(--brand-muted);\n}\n\n.sidebar-loop.done {\n  font-weight: 500;\n  color: var(--brand-muted);\n  text-decoration-line: none;\n}\n\n/* Pastor Rob's book: a title in his own serif and one link. */\n.sidebar-book {\n  margin: 4px 14px 10px;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--brand-muted);\n}\n\n.sidebar-book-title {\n  display: block;\n  font-family: var(--font-serif);\n  font-style: normal;\n  font-weight: 440;\n  font-size: 1rem;\n  line-height: 1.3;\n  font-variation-settings: \"opsz\" 18;\n  color: var(--brand-fg);\n}\n\n.sidebar-book .sidebar-give-cta {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n/* \"Follow The Net\": three plain words, each a full-size target. */\n.sidebar-follow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 14px;\n  margin: 0 14px 2px;\n  font-size: 0.8125rem;\n  line-height: 1.3;\n  color: var(--brand-subtle);\n}\n\n.sidebar-follow-label {\n  flex-basis: 100%;\n  font-weight: 600;\n  color: var(--brand-muted);\n}\n\n.sidebar-follow a {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  color: var(--brand-fg);\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n}\n\n.sidebar-promise {\n  margin: 0 14px 6px;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: var(--brand-subtle);\n}\n\n.sidebar-policies {\n  padding: 0 14px;\n  font-size: 0.8125rem;\n  line-height: 2;\n  color: var(--brand-subtle);\n}\n\n.sidebar-policies a {\n  color: var(--brand-muted);\n}\n\n.sidebar-about {\n  margin: 4px 14px 2px;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  color: var(--brand-subtle);\n}\n\n.sidebar-about a {\n  color: var(--brand-muted);\n}\n\n.sidebar-backdrop {\n  display: none;\n}\n\n/* The fold button (wide screens) and the rail's own icons (folded only). */\n.sidebar-fold {\n  display: grid;\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-md);\n  color: var(--brand-muted);\n}\n\n.sidebar-fold:hover {\n  color: var(--brand-fg);\n  background: var(--brand-surface-2);\n}\n\n.sidebar-fold-mark {\n  display: none;\n  color: var(--brand-fg);\n}\n\n.sidebar-fold-mark .apr-mark {\n  display: block;\n  height: 22px;\n  width: auto;\n}\n\n.rail-only {\n  display: none;\n}\n\n.sidebar-rail-btn {\n  place-items: center;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-md);\n  color: var(--brand-muted);\n  text-decoration: none;\n}\n\n.sidebar-rail-btn:hover {\n  color: var(--brand-fg);\n  background: var(--brand-surface-2);\n}\n\n/*\n * Folded (wide screens only): a 68 px rail of 44 px icons. Every word stays\n * in the page for screen readers; each icon shows its name beside it on\n * hover or keyboard focus. Saved conversations, the account line, support's\n * sentence and the policies wait in the open menu.\n */\n@media (min-width: 901px) {\n  .sidebar.folded {\n    width: 68px;\n    min-width: 68px;\n    padding: 12px 12px calc(12px + env(safe-area-inset-bottom, 0px));\n    align-items: center;\n    overflow: visible;\n  }\n\n  .sidebar.folded .sidebar-brand {\n    padding: 0;\n    margin-bottom: 8px;\n    justify-content: center;\n  }\n\n  .sidebar.folded .sidebar-lockup,\n  .sidebar.folded .sidebar-section-label,\n  .sidebar.folded .sidebar-chats,\n  .sidebar.folded .sidebar-user,\n  .sidebar.folded .sidebar-give,\n  .sidebar.folded .sidebar-loop,\n  .sidebar.folded .sidebar-promise,\n  .sidebar.folded .sidebar-book,\n  .sidebar.folded .sidebar-follow,\n  .sidebar.folded .sidebar-policies,\n  .sidebar.folded .sidebar-about,\n  .sidebar.folded .sidebar-nav-item.sub,\n  .sidebar.folded .nav-ext,\n  .sidebar.folded .apr-switch-track {\n    display: none;\n  }\n\n  .sidebar.folded .nav-text,\n  .sidebar.folded .rail-words {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip-path: inset(50%);\n    white-space: nowrap;\n  }\n\n  .sidebar.folded .sidebar-new-chat {\n    width: 44px;\n    min-height: 44px;\n    padding: 0;\n    justify-content: center;\n  }\n\n  .sidebar.folded .sidebar-nav {\n    align-items: center;\n  }\n\n  .sidebar.folded .sidebar-nav-item,\n  .sidebar.folded .sidebar-nav-item:has(.nav-hint),\n  .sidebar.folded .sidebar-setting,\n  .sidebar.folded .sidebar-setting:has(small) {\n    width: 44px;\n    min-height: 44px;\n    padding: 0;\n    justify-content: center;\n  }\n\n  /* The current view's bar sits on the rail's edge. */\n  .sidebar.folded .sidebar-nav-item.active::before {\n    left: -12px;\n  }\n\n  .sidebar.folded .nav-dot {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    margin: 0;\n  }\n\n  /* A switch that is on keeps a filled square behind its icon. */\n  .sidebar.folded .sidebar-setting[aria-checked=\"true\"] {\n    background: var(--brand-surface-2);\n  }\n\n  .sidebar.folded .sidebar-footer {\n    margin-top: auto;\n    padding-top: 8px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .sidebar.folded .rail-only {\n    display: grid;\n  }\n\n  .sidebar.folded .sidebar-fold-mark {\n    display: block;\n  }\n\n  .sidebar.folded .sidebar-fold-icon {\n    display: none;\n  }\n\n  .sidebar.folded .sidebar-fold:hover .sidebar-fold-mark,\n  .sidebar.folded .sidebar-fold:focus-visible .sidebar-fold-mark {\n    display: none;\n  }\n\n  .sidebar.folded .sidebar-fold:hover .sidebar-fold-icon,\n  .sidebar.folded .sidebar-fold:focus-visible .sidebar-fold-icon {\n    display: block;\n  }\n\n  /* Names on hover and keyboard focus, to the right of the rail. */\n  .sidebar.folded [data-tip] {\n    position: relative;\n  }\n\n  .sidebar.folded [data-tip]:hover::after,\n  .sidebar.folded [data-tip]:focus-visible::after {\n    content: attr(data-tip);\n    position: absolute;\n    z-index: 70;\n    left: calc(100% + 12px);\n    top: 50%;\n    transform: translateY(-50%);\n    padding: 6px 10px;\n    border-radius: var(--radius-md);\n    background: var(--brand-fg);\n    color: var(--brand-bg);\n    font-family: var(--font-sans);\n    font-size: 0.8125rem;\n    font-weight: 500;\n    line-height: 1.3;\n    white-space: nowrap;\n    pointer-events: none;\n  }\n}\n\n@media (max-width: 900px) {\n  .sidebar {\n    position: fixed;\n    z-index: 60;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: min(86vw, 340px);\n    min-width: 0;\n    padding-top: calc(6px + env(safe-area-inset-top, 0px));\n    padding-right: calc(12px + env(safe-area-inset-right, 0px));\n    background: var(--brand-surface);\n    border-right: 0;\n    border-left: 1px solid var(--brand-line-control);\n    transform: translateX(105%);\n    visibility: hidden;\n    transition: transform var(--dur-base) var(--ease-out), visibility 0s linear var(--dur-base);\n  }\n\n  .sidebar.open {\n    transform: none;\n    visibility: visible;\n    transition: transform var(--dur-base) var(--ease-out), visibility 0s linear 0s;\n  }\n\n  .sidebar-close {\n    display: grid;\n  }\n\n  .sidebar-fold {\n    display: none;\n  }\n\n  .sidebar-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    z-index: 55;\n    background: var(--brand-scrim);\n    animation: aprScrimIn var(--dur-fast) var(--ease-out);\n  }\n}\n\n/* Short screens (landscape phones): one scroll for the whole menu instead of\n   a conversation list squeezed to a sliver between the nav and the footer. */\n@media (max-height: 500px) {\n  .sidebar {\n    overflow-y: auto;\n    overscroll-behavior: contain;\n  }\n\n  .sidebar-chats {\n    flex: none;\n    overflow: visible;\n  }\n}\n\n/* ---- Rob's voice, for the team only (TeamVoicePick): two choices joined like the answer style ---- */\n\n.sidebar-voice-pick {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 4px 10px 10px 14px;\n}\n\n.sidebar-voice-pick-label {\n  font-size: 0.9375rem;\n  font-weight: 500;\n  line-height: 1.35;\n  color: var(--brand-fg);\n}\n\n.sidebar-voice-pick-label small {\n  display: block;\n  margin-top: 1px;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.35;\n  color: var(--brand-muted);\n}\n\n.sidebar-voice-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.sidebar-voice-option {\n  min-width: 0;\n  min-height: 44px;\n  padding: 0 10px;\n  border: 1px solid var(--brand-line-control);\n  background: transparent;\n  color: var(--brand-muted);\n  font-size: 0.875rem;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.sidebar-voice-option:first-child { border-radius: var(--radius-md) 0 0 var(--radius-md); }\n.sidebar-voice-option:last-child { border-radius: 0 var(--radius-md) var(--radius-md) 0; margin-left: -1px; }\n.sidebar-voice-option:hover { color: var(--brand-fg); }\n\n.sidebar-voice-option.on {\n  position: relative;\n  z-index: 1;\n  border-color: var(--brand-fg);\n  box-shadow: inset 0 0 0 1px var(--brand-fg);\n  color: var(--brand-fg);\n}\n\n/* The folded rail has no room for it: it waits in the open menu. */\n@media (min-width: 901px) {\n  .sidebar.folded .sidebar-voice-pick { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
